<template>
  <svg width="18"
       height="15"
       viewBox="0 0 18 15"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M0.676758 7.64551C0.676758 7.90918 0.791016 8.17285 0.993164 8.36621L6.79395 14.1582C7.00488 14.3604 7.2334 14.457 7.48828 14.457C8.04199 14.457 8.44629 14.0615 8.44629 13.5254C8.44629 13.2441 8.34082 13.0068 8.15625 12.8311L6.17871 10.8271L3.62988 8.49805L5.67773 8.62109H16.3301C16.9102 8.62109 17.3145 8.2168 17.3145 7.64551C17.3145 7.06543 16.9102 6.66113 16.3301 6.66113H5.67773L3.63867 6.78418L6.17871 4.45508L8.15625 2.45117C8.34082 2.27539 8.44629 2.03809 8.44629 1.75684C8.44629 1.2207 8.04199 0.825195 7.48828 0.825195C7.2334 0.825195 6.99609 0.921875 6.76758 1.1416L0.993164 6.91602C0.791016 7.10938 0.676758 7.37305 0.676758 7.64551Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'ArrowRightIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 18
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
</script>

<style>

</style>
